module.exports = __webpack_public_path__ + "img/heart.4652fe80.gif";